// 로딩 화면·검색 0건 화면에 랜덤으로 띄우는 브루드워 잡학 팁 — /api/tips가 실패하거나
// 아직 fetch 전일 때 쓰는 폴백. 어드민 "팁" 탭에서 관리하는 DB 목록과 별개 사본이라
// DB에 새로 추가해도 여긴 자동 반영 안 됨 — 가끔 수동으로 맞춰줄 것(2026-09-08 기준 동기화).
export const BW_TIPS: string[] = [
  "커맨드센터의 건설 시간은 75.8초입니다.",
  "TvP에서 드라군 사정거리 업그레이드는 04:30에 완료됩니다.",
  "생더블 커맨드 건설 시작 시점은 01:57 입니다.",
  "생더블 커맨드 건설 완료 시점은 03:15 입니다.",
  "19넥은 03:00에 건설이 시작됩니다.",
  "23넥은 03:32에 건설이 시작됩니다.",
  "12넥서스의 건설은 01:45에 시작됩니다.",
  "12넥서스의 건설 완료 시점은 03:03 입니다.",
  "9오버풀의 스포닝 풀은 01:15에 건설 시작됩니다.",
  "9투 해처리 건설 시작 시점은 01:15 입니다.",
  "9투 해처리 건설 완료 시점은 02:30 입니다.",
  "TvP에서 2번째 아비터가 나왔다는건 첫 아비터의 마나가 130정도 찼다는 의미입니다.",
  "ZvT에서 3분 2초에 본진에서 레어를 누르면 라바가 1개 추가 생성됩니다.",
  "/ignore <닉네임>으로 상대 채팅을 차단할 수 있습니다.",
  "/o igw으로 친구가 아닌 사용자의 귓속말을 차단할 수 있습니다.",
  "ZvT에서 03:30에 앞마당에 성큰을 건설하면 첫번째 벌처의 난입을 막을 수 있습니다.",
  "TvP에서 04:05가 지나서도 앞마당 넥서스가 건설되지 않는다면 다크/리버를 의심해야 합니다.",
  "TvZ에서 12앞 2햇 러커는 05:50쯤에 테란 앞마당에 도착합니다.",
  "플레이 중 Ctrl Q Q를 누르면 빠른 퇴장이 가능합니다.",
  "광클 리페어는 수리 속도에 전혀 도움이 되지 않고, 수리 비용만 훨씬 더 많이 나갑니다.",
  "가스 104를 캐는 데 걸리는 시간은 20초이므로, 가스 완성 20초 뒤에 레어가 찍히면 선레어로 확정할 수 있습니다.",
  "11앞은 01:34, 12앞은 01:40에 건설이 시작됩니다.",
  "9발업은 저글링 발업이 03:10에 완료됩니다.",
  "TvP에서 첫 드라군은 03:07에, 두번째 드라군은 03:40에 등장합니다.",
  "TvP에서 14질은 02:35~02:40에 등장합니다.",
  "ZvT에서 배럭더블은 커맨드센터가 아무리 늦어도 03:00전에 건설 시작됩니다.",
  "TvP에서 첫 옵저버는 06:10에 등장합니다.",
  "TvZ에서 12앞 2해처리 가스 기준으로 저글링 발업은 04:10에 완료됩니다.",
  "TvP에서 정석 더블 기준으로 06:30에 다크드랍/리버가 출발합니다.",
  "ZvT에서 2배럭 아카데미(23아카) 병력은 04:50에 출발합니다.",
  "ZvT에서 선엔베 빌드는 09:30에 공방 1/1업이 완료됩니다.",
  "플레이 도중 Shift+Tab을 두번 누르면 색깔을 변경할 수 있습니다.",
  "TvP에서 14질럿은 03:20에 테란 앞마당에 도착합니다.",
  "TvZ에서 저그가 530 빌드일 경우 04:40에 엔베를 건설해야 합니다.",
  "TvP에서 노사업 로보틱스 기준으로 리버는 06:20에 테란 앞마당에 도착합니다.",
];
